import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import type { IIngestIncident } from "@nendaTypes/NendaTypes";

interface IncidentListProps {
  incidents: IIngestIncident[];
  variant?: "embedded" | "card"; // embedded = in expandable row, card = standalone card
}

const INCIDENT_LABELS: Partial<Record<string, string>> = {
  metadata_warning: "Metadata Fallback",
  phase_timeout: "Phase Timeout",
  ingesting_retry: "Ingesting Retry",
  transcode_failed: "Transcode failed",
};

function formatDate(date?: Date | string): string {
  if (!date) return "—";
  return new Date(date).toLocaleString("sv-SE");
}

export const IncidentList: React.FC<IncidentListProps> = ({
  incidents,
  variant = "embedded",
}) => {
  if (!incidents || incidents.length === 0) {
    return null;
  }

  return (
    <Stack spacing={1}>
      {incidents.map((incident, idx) => (
        <Box
          key={idx}
          sx={{
            p: 1.5,
            bgcolor: "background.paper",
            borderRadius: 1,
            borderLeft: "3px solid",
            borderColor:
              incident.type === "metadata_warning"
                ? "warning.main"
                : "info.main",
          }}
        >
          <Stack
            direction="row"
            spacing={2}
            alignItems="flex-start"
            sx={{ mb: 0.5 }}
          >
            <Typography variant="body2" sx={{ fontWeight: 500, flex: 1 }}>
              {INCIDENT_LABELS[incident.type] ?? incident.type}
            </Typography>
            <Typography variant="caption" color="text.disabled">
              Attempt {incident.attempt}
            </Typography>
          </Stack>
          {incident.details && (
            <Typography variant="body2" color="text.primary">
              {incident.details}
            </Typography>
          )}
          <Typography
            variant="caption"
            color="text.disabled"
            sx={{ display: "block", mt: 0.5 }}
          >
            {formatDate(incident.occurredAt)}
          </Typography>
        </Box>
      ))}
    </Stack>
  );
};
